import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Global 401 handler — if any API call returns "Invalid or expired token",
// clear the token and bounce to /admin/login (only when the user is in /admin).
// This prevents the dashboard from silently dying on stale tokens.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    if (status === 401 && window.location.pathname.startsWith("/admin")) {
      localStorage.removeItem("admin_token");
      // Avoid an infinite loop if we're already on /admin/login
      if (!window.location.pathname.startsWith("/admin/login")) {
        window.location.href = "/admin/login?expired=1";
      }
    }
    return Promise.reject(err);
  }
);

export const setAdminToken = (token) => {
  if (token) localStorage.setItem("admin_token", token);
  else localStorage.removeItem("admin_token");
};

export const getAdminToken = () => localStorage.getItem("admin_token");
